'use client'

import { useRef } from 'react'

type Testimonial = {
  quote: string
  name: string
  detail?: string
  category?: string
}

export function TestimonialCarousel({ items }: { items: Testimonial[] }) {
  const scrollerRef = useRef<HTMLDivElement>(null)

  function scroll(direction: 'left' | 'right') {
    const el = scrollerRef.current
    if (!el) return
    const amount = el.clientWidth * 0.85
    el.scrollBy({ left: direction === 'left' ? -amount : amount, behavior: 'smooth' })
  }

  return (
    <div className="relative">
      <div
        ref={scrollerRef}
        className="flex gap-4 overflow-x-auto scroll-smooth pb-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      >
        {items.map((item) => (
          <figure
            key={item.name}
            className="m-0 w-[260px] flex-shrink-0 rounded-2xl border border-[#2B0A4A]/10 bg-white p-5 shadow-[0_10px_25px_rgba(73,45,16,0.06)]"
          >
            {item.category && (
              <span className="text-[10px] font-extrabold uppercase tracking-[0.1em] text-[#FF8A3D]">
                {item.category}
              </span>
            )}
            <blockquote className="mt-2 text-sm italic leading-relaxed text-[#1B0044]/80">
              &ldquo;{item.quote}&rdquo;
            </blockquote>
            <figcaption className="mt-3 text-xs text-[#786C7B]">
              <b className="text-[#1B0044]">{item.name}</b>
              {item.detail && <> · {item.detail}</>}
            </figcaption>
          </figure>
        ))}
      </div>

      <button
        type="button"
        onClick={() => scroll('left')}
        aria-label="Scroll testimonials left"
        className="absolute left-0 top-1/2 z-10 flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-[#2B0A4A]/15 bg-white text-[#2B0A4A] shadow-[0_8px_20px_rgba(43,10,74,0.18)] transition hover:bg-[#FFF8EC]"
      >
        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
        </svg>
      </button>
      <button
        type="button"
        onClick={() => scroll('right')}
        aria-label="Scroll testimonials right"
        className="absolute right-0 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 translate-x-1/2 items-center justify-center rounded-full border border-[#2B0A4A]/15 bg-white text-[#2B0A4A] shadow-[0_8px_20px_rgba(43,10,74,0.18)] transition hover:bg-[#FFF8EC]"
      >
        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
        </svg>
      </button>
    </div>
  )
}
